<div class="today_chart_card">
    <mat-card appearance="outlined">
    <div class="vier_tht">
       <div class="heading_ot">
       <h3>Daily Booking </h3> 
      </div>
  </div>
  <div class="booking_chart" *ngIf="!loader && bookingsData.length > 0">
    <sm-line-chart-for-dashboard  [dataSource]="bookingsGraphData"></sm-line-chart-for-dashboard>
  </div> 
  <div class="placeholder_img_d" *ngIf="!loader && bookingsData.length == 0">
   <img src="../../../../../../../assets/images/chart-1.png" alt="Daily booking image"/>
  </div>         
</mat-card>
</div>
